//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IconView from "@/components/objects/IconView.vue";
import { ObjectLink } from "@/utils/dto/objects.js";
import { BUILD_STORAGE_IMAGE_PATH } from "@/constants/ui.js";

export default {
  name: "LinksSquareObject",
  components: { IconView },
  inject: ['source'],
  props: {
    item: {
      type: [Object, ObjectLink],
      default: () => {
        return {
          id: "",
          label: "",
          text: ""
        }
      }
    },
    useStorage: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: 'square'
    }
  },
  computed: {
    hasImage() {
      return this.item.target_object.has_image
    },
    imagePath() {
      if (this.hasImage) {
        if (this.useStorage) {
          return BUILD_STORAGE_IMAGE_PATH(this.item.image)
        } else {
          return `/public/object_images_files/first_image/${this.item.target_object.id}/?preview=1`
        }

      } else return null
    },
    iconPath() {
      if (this.item.target_object.type) {
        return this.item.target_object.type.icon
      } else {
        return this.item.target_object.icon
      }
    }
  },
}
